export default{
    adminUrl : "http://ai.qceit.cn"
}